/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "אתמול",
        "-2": "שלשום",
        "0": "היום",
        "1": "מחר",
        "2": "מחרתיים",
        "future": {
          "many": "בעוד {0} ימים",
          "one": "בעוד יום {0}",
          "other": "בעוד {0} ימים",
          "two": "בעוד יומיים"
        },
        "past": {
          "many": "לפני {0} ימים",
          "one": "לפני יום {0}",
          "other": "לפני {0} ימים",
          "two": "לפני יומיים"
        }
      },
      "day-narrow": {
        "-1": "אתמול",
        "-2": "שלשום",
        "0": "היום",
        "1": "מחר",
        "2": "מחרתיים",
        "future": {
          "many": "בעוד {0} ימים",
          "one": "מחר",
          "other": "בעוד {0} ימים",
          "two": "בעוד יומיים"
        },
        "past": {
          "many": "לפני {0} ימים",
          "one": "אתמול",
          "other": "לפני {0} ימים",
          "two": "לפני יומיים"
        }
      },
      "day-short": {
        "-1": "אתמול",
        "-2": "שלשום",
        "0": "היום",
        "1": "מחר",
        "2": "מחרתיים",
        "future": {
          "many": "בעוד {0} ימים",
          "one": "מחר",
          "other": "בעוד {0} ימים",
          "two": "בעוד יומיים"
        },
        "past": {
          "many": "לפני {0} ימים",
          "one": "אתמול",
          "other": "לפני {0} ימים",
          "two": "לפני יומיים"
        }
      },
      "hour": {
        "0": "בשעה זו",
        "future": {
          "many": "בעוד {0} שעות",
          "one": "בעוד שעה",
          "other": "בעוד {0} שעות",
          "two": "בעוד שעתיים"
        },
        "past": {
          "many": "לפני {0} שעות",
          "one": "לפני שעה",
          "other": "לפני {0} שעות",
          "two": "לפני שעתיים"
        }
      },
      "hour-narrow": {
        "0": "בשעה זו",
        "future": {
          "many": "בעוד {0} שע׳",
          "one": "בעוד שעה",
          "other": "בעוד {0} שע׳",
          "two": "בעוד שעתיים"
        },
        "past": {
          "many": "לפני {0} שע׳",
          "one": "לפני שעה",
          "other": "לפני {0} שע׳",
          "two": "לפני שעתיים"
        }
      },
      "hour-short": {
        "0": "בשעה זו",
        "future": {
          "many": "בעוד {0} שע׳",
          "one": "בעוד שעה",
          "other": "בעוד {0} שע׳",
          "two": "בעוד שעתיים"
        },
        "past": {
          "many": "לפני {0} שע׳",
          "one": "לפני שעה",
          "other": "לפני {0} שע׳",
          "two": "לפני שעתיים"
        }
      },
      "minute": {
        "0": "בדקה זו",
        "future": {
          "many": "בעוד {0} דקות",
          "one": "בעוד דקה",
          "other": "בעוד {0} דקות",
          "two": "בעוד שתי דקות"
        },
        "past": {
          "many": "לפני {0} דקות",
          "one": "לפני דקה",
          "other": "לפני {0} דקות",
          "two": "לפני שתי דקות"
        }
      },
      "minute-narrow": {
        "0": "דקה זו",
        "future": {
          "many": "בעוד {0} דק׳",
          "one": "בעוד דקה",
          "other": "בעוד {0} דק׳",
          "two": "בעוד שתי דק׳"
        },
        "past": {
          "many": "לפני {0} דק׳",
          "one": "לפני דקה",
          "other": "לפני {0} דק׳",
          "two": "לפני שתי דק׳"
        }
      },
      "minute-short": {
        "0": "דקה זו",
        "future": {
          "many": "בעוד {0} דק׳",
          "one": "בעוד דקה",
          "other": "בעוד {0} דק׳",
          "two": "בעוד שתי דק׳"
        },
        "past": {
          "many": "לפני {0} דק׳",
          "one": "לפני דקה",
          "other": "לפני {0} דק׳",
          "two": "לפני {0} דק׳"
        }
      },
      "month": {
        "-1": "החודש שעבר",
        "0": "החודש",
        "1": "החודש הבא",
        "future": {
          "many": "בעוד {0} חודשים",
          "one": "בעוד חודש",
          "other": "בעוד {0} חודשים",
          "two": "בעוד חודשיים"
        },
        "past": {
          "many": "לפני {0} חודשים",
          "one": "לפני חודש",
          "other": "לפני {0} חודשים",
          "two": "לפני חודשיים"
        }
      },
      "month-narrow": {
        "-1": "החודש שעבר",
        "0": "החודש",
        "1": "החודש הבא",
        "future": {
          "many": "בעוד {0} חו׳",
          "one": "בעוד חו׳",
          "other": "בעוד {0} חו׳",
          "two": "בעוד חודשיים"
        },
        "past": {
          "many": "לפני {0} חו׳",
          "one": "לפני חו׳",
          "other": "לפני {0} חו׳",
          "two": "לפני חודשיים"
        }
      },
      "month-short": {
        "-1": "החודש שעבר",
        "0": "החודש",
        "1": "החודש הבא",
        "future": {
          "many": "בעוד {0} חודשים",
          "one": "בעוד חודש",
          "other": "בעוד {0} חודשים",
          "two": "בעוד חודשיים"
        },
        "past": {
          "many": "לפני {0} חודשים",
          "one": "לפני חודש",
          "other": "לפני {0} חודשים",
          "two": "לפני חודשיים"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "הרבעון הקודם",
        "0": "רבעון זה",
        "1": "הרבעון הבא",
        "future": {
          "many": "בעוד {0} רבעונים",
          "one": "ברבעון הבא",
          "other": "בעוד {0} רבעונים",
          "two": "בעוד שני רבעונים"
        },
        "past": {
          "many": "לפני {0} רבעונים",
          "one": "ברבעון הקודם",
          "other": "לפני {0} רבעונים",
          "two": "לפני שני רבעונים"
        }
      },
      "quarter-narrow": {
        "-1": "הרבעון הקודם",
        "0": "רבעון זה",
        "1": "הרבעון הבא",
        "future": {
          "many": "בעוד {0} רבע׳",
          "one": "ברבע׳ הבא",
          "other": "בעוד {0} רבע׳",
          "two": "בעוד שני רבע׳"
        },
        "past": {
          "many": "לפני {0} רבע׳",
          "one": "ברבע׳ הקודם",
          "other": "לפני {0} רבע׳",
          "two": "לפני שני רבע׳"
        }
      },
      "quarter-short": {
        "-1": "הרבעון הקודם",
        "0": "רבעון זה",
        "1": "הרבעון הבא",
        "future": {
          "many": "בעוד {0} רבע׳",
          "one": "ברבע׳ הבא",
          "other": "בעוד {0} רבע׳",
          "two": "בעוד שני רבע׳"
        },
        "past": {
          "many": "לפני {0} רבע׳",
          "one": "ברבע׳ הקודם",
          "other": "לפני {0} רבע׳",
          "two": "לפני שני רבע׳"
        }
      },
      "second": {
        "0": "עכשיו",
        "future": {
          "many": "בעוד {0} שניות",
          "one": "בעוד שנייה",
          "other": "בעוד {0} שניות",
          "two": "בעוד שתי שניות"
        },
        "past": {
          "many": "לפני {0} שניות",
          "one": "לפני שנייה",
          "other": "לפני {0} שניות",
          "two": "לפני שתי שניות"
        }
      },
      "second-narrow": {
        "0": "עכשיו",
        "future": {
          "many": "בעוד {0} שנ׳",
          "one": "בעוד שנ׳",
          "other": "בעוד {0} שנ׳",
          "two": "בעוד שתי שנ׳"
        },
        "past": {
          "many": "לפני {0} שנ׳",
          "one": "לפני שנ׳",
          "other": "לפני {0} שנ׳",
          "two": "לפני שתי שנ׳"
        }
      },
      "second-short": {
        "0": "עכשיו",
        "future": {
          "many": "בעוד {0} שנ׳",
          "one": "בעוד שנ׳",
          "other": "בעוד {0} שנ׳",
          "two": "בעוד שתי שנ׳"
        },
        "past": {
          "many": "לפני {0} שנ׳",
          "one": "לפני שנ׳",
          "other": "לפני {0} שנ׳",
          "two": "לפני שתי שנ׳"
        }
      },
      "week": {
        "-1": "השבוע שעבר",
        "0": "השבוע",
        "1": "השבוע הבא",
        "future": {
          "many": "בעוד {0} שבועות",
          "one": "בעוד שבוע",
          "other": "בעוד {0} שבועות",
          "two": "בעוד שבועיים"
        },
        "past": {
          "many": "לפני {0} שבועות",
          "one": "לפני שבוע",
          "other": "לפני {0} שבועות",
          "two": "לפני שבועיים"
        }
      },
      "week-narrow": {
        "-1": "השבוע שעבר",
        "0": "השבוע",
        "1": "השבוע הבא",
        "future": {
          "many": "בעוד {0} שב׳",
          "one": "בעוד שב׳",
          "other": "בעוד {0} שב׳",
          "two": "בעוד שבועיים"
        },
        "past": {
          "many": "לפני {0} שב׳",
          "one": "לפני שבוע",
          "other": "לפני {0} שב׳",
          "two": "לפני שבועיים"
        }
      },
      "week-short": {
        "-1": "השבוע שעבר",
        "0": "השבוע",
        "1": "השבוע הבא",
        "future": {
          "many": "בעוד {0} שב׳",
          "one": "בעוד שב׳",
          "other": "בעוד {0} שב׳",
          "two": "בעוד שבועיים"
        },
        "past": {
          "many": "לפני {0} שב׳",
          "one": "לפני שב׳",
          "other": "לפני {0} שב׳",
          "two": "לפני שבועיים"
        }
      },
      "year": {
        "-1": "השנה שעברה",
        "0": "השנה",
        "1": "השנה הבאה",
        "future": {
          "many": "בעוד {0} שנה",
          "one": "בעוד שנה",
          "other": "בעוד {0} שנים",
          "two": "בעוד שנתיים"
        },
        "past": {
          "many": "לפני {0} שנה",
          "one": "לפני שנה",
          "other": "לפני {0} שנים",
          "two": "לפני שנתיים"
        }
      },
      "year-narrow": {
        "-1": "השנה שעברה",
        "0": "השנה",
        "1": "השנה הבאה",
        "future": {
          "many": "בעוד {0} שנה",
          "one": "בעוד שנה",
          "other": "בעוד {0} שנים",
          "two": "בעוד שנתיים"
        },
        "past": {
          "many": "לפני {0} שנה",
          "one": "לפני שנה",
          "other": "לפני {0} שנים",
          "two": "לפני שנתיים"
        }
      },
      "year-short": {
        "-1": "השנה שעברה",
        "0": "השנה",
        "1": "השנה הבאה",
        "future": {
          "many": "בעוד {0} שנה",
          "one": "בעוד שנה",
          "other": "בעוד {0} שנים",
          "two": "בעוד שנתיים"
        },
        "past": {
          "many": "לפני {0} שנה",
          "one": "לפני שנה",
          "other": "לפני {0} שנים",
          "two": "לפני שנתיים"
        }
      }
    },
    "locale": "he"
  });
}